import React, { ReactNode, useContext } from "react";
import { Grid, Box } from "@mui/material";
import {
  EnvironmentIndicator,
  environmentAbbreviation,
  shouldDisplayEnvironmentIndicator,
  PreviewStatus,
} from "@coherehealth/common";
import config from "../api/config";
import { UserContext } from "UserContext";
import { LeftNavBar } from "./common/Navigation/LeftNavBar";

export interface AppLayoutProps {
  children: ReactNode;
  hideEnvIndicator?: boolean;
}

const AppLayout = ({ children, hideEnvIndicator }: AppLayoutProps) => {
  const { queueView } = useContext(UserContext);
  const drawerWidth = 76;
  const env = environmentAbbreviation();
  const displayEnvIndicator = !hideEnvIndicator && shouldDisplayEnvironmentIndicator(env);
  const envIndicatorHeight = displayEnvIndicator ? 35 : 0;
  return (
    <Grid container>
      {displayEnvIndicator && (
        <Box sx={{ width: "100%", position: "fixed", top: 0, zIndex: 5 }}>
          <EnvironmentIndicator env={env} />
        </Box>
      )}
      <Grid sx={{ width: drawerWidth }}>
        <LeftNavBar drawerWidth={drawerWidth} queueViewState={queueView} />
      </Grid>
      <Grid
        sx={{
          width: `calc(100% - ${drawerWidth}px)`,
          position: "absolute",
          left: drawerWidth,
          top: envIndicatorHeight,
          height: `calc(100% - ${envIndicatorHeight}px)`,
        }}
      >
        {config.PREVIEW_ID && (
          <PreviewStatus
            previewId={config.PREVIEW_ID}
            gitHash={config.CURRENT_GIT_HASH}
            pullRequestNumber={config.PR_NUMBER}
          />
        )}
        {children}
      </Grid>
    </Grid>
  );
};

export default AppLayout;
